export interface ENUM {
  [name: string]: any;
}
export interface STRING_ENUM {
  [name: string]: string;
}

export function isEnumValue<T extends ENUM>(x: unknown, e: T): x is T[keyof T] {
  return Object.values(e).includes(x);
}

export function getNumericEnumValues<T extends ENUM>(e: T): number[] {
  return Object.values(e).filter((value) => typeof value === "number");
}

export function safeParseEnum<T extends ENUM>(
  value: unknown,
  e: T,
): T[keyof T] | undefined {
  return isEnumValue(value, e) ? value : undefined;
}

export function joinEnumMap<T extends string>(
  enumObj: Record<string, T>,
  map: Record<T, string>,
  sep = "\n",
): string {
  return Object.values(enumObj)
    .map((v) => map[v])
    .join(sep);
}
